import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@pcln/horizon";
import { forwardRef } from "react";
import { searchFormCard } from "./SearchFormCard.variants.js";
const SearchFormCard_SearchFormCard = /*#__PURE__*/ forwardRef(function({ 'aria-label': ariaLabel = 'Search form', children, className, contentClassName, footer, header, role = 'region', tabs, tabsPosition = 'above', variant = 'panel', width = 'full', ...props }, ref) {
    const styles = searchFormCard({
        variant,
        width
    });
    return /*#__PURE__*/ jsxs("div", {
        "aria-label": ariaLabel,
        className: cn(styles.root(), className),
        ref: ref,
        role: role,
        ...props,
        children: [
            tabs && 'above' === tabsPosition && tabs,
            header,
            tabs && 'below' === tabsPosition && tabs,
            /*#__PURE__*/ jsx("div", {
                className: cn(styles.content(), contentClassName),
                children: children
            }),
            footer
        ]
    });
});
export { SearchFormCard_SearchFormCard as SearchFormCard };
